import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function WelcomeScreen() {
  const [showWelcome, setShowWelcome] = useState(false);
  const [typewriterText, setTypewriterText] = useState('');
  const [showFooter, setShowFooter] = useState(false);
  const navigate = useNavigate();
  
  const fullText = 'RESTOBOXX';

  useEffect(() => {
    // Show "Welcome To" swiftly after a short delay
    const welcomeTimer = setTimeout(() => {
      setShowWelcome(true);
    }, 300);

    // Start typewriter animation after welcome text appears
    const typewriterTimer = setTimeout(() => {
      let currentIndex = 0;
      const typingInterval = setInterval(() => {
        if (currentIndex <= fullText.length) {
          setTypewriterText(fullText.slice(0, currentIndex));
          currentIndex++;
        } else {
          clearInterval(typingInterval);
          // Show footer after typewriter completes
          setTimeout(() => {
            setShowFooter(true);
            // Navigate to dashboard after showing complete animation
            setTimeout(() => {
              navigate('/dashboard');
            }, 2000);
          }, 300);
        }
      }, 150);

      return () => clearInterval(typingInterval);
    }, 1200);

    return () => {
      clearTimeout(welcomeTimer);
      clearTimeout(typewriterTimer);
    };
  }, [navigate, fullText]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 via-purple-600 to-purple-800 overflow-hidden relative">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-1/2 -left-1/2 w-full h-full bg-blue-500 rounded-full opacity-20 animate-pulse"></div>
        <div className="absolute -bottom-1/2 -right-1/2 w-full h-full bg-purple-500 rounded-full opacity-20 animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-8">
        {/* Welcome To - Swift entrance */}
        <div 
          className={`transition-all duration-500 ease-out transform ${
            showWelcome ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
          }`}
        >
          <h2 className="text-2xl md:text-4xl font-light text-white mb-4 tracking-wide">
            Welcome To
          </h2>
        </div>

        {/* RESTOBOXX - Typewriter animation */}
        <div className="min-h-[120px] flex items-center justify-center">
          <h1 className="brand-wordmark brand-wordmark-caps text-5xl md:text-8xl text-white">
            {typewriterText}
            <span className="animate-pulse">|</span>
          </h1>
        </div>

        {/* Footer - Fades in after typewriter */}
        <div 
          className={`mt-12 transition-all duration-700 ease-in transform ${
            showFooter ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <div className="space-y-3">
            <p className="text-lg md:text-xl text-white font-medium">
              Powered by <span className="font-bold text-blue-200">Prosoft Logic Systems</span>
            </p>
            <p className="text-base md:text-lg text-blue-100 font-light italic">
              AI Business Solutions
            </p>
          </div>
        </div>

        {/* Loading indicator */}
        {showFooter && (
          <div className="mt-8 flex justify-center">
            <div className="flex space-x-2">
              <div className="w-3 h-3 bg-white rounded-full animate-bounce"></div>
              <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
              <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default WelcomeScreen;
